module.exports = __webpack_public_path__ + "static/FuturaPTMedium-bd99f124d37cfd9caecec4fe24094334.otf";